export const getAvatarInitials = (name = "0 0") => {
  const avatar = name.split(" ");
  return avatar[0][0] + avatar[avatar.length - 1][0];
};
